<template>
  <div class="match-hero-live">

    <div class="hero-content" :class="isTennisOrTableTennis(event) ? 'tennis' : ''">
      <div class="team-col home"  v-if="!isTennisOrTableTennis(event)">
        <LogoCompetitors :team-id="event.home_id" height="50px" width="50px" class="team-logo "/>
        <div class="column">
          <div class="team-name">{{ event.home }}</div>
          <div class="scorers-list" v-if="scorersByTeam.home.length > 0">
            <div class="scorer-item" v-for="scorer in scorersByTeam.home" :key="scorer.name">
              <svg class="scorer-ball" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15.93V16h2v1.93c-0.33 0.04-0.66 0.07-1 0.07s-0.67-0.03-1-0.07zm4-1.02V15l-3-2-3 2v1.91C7.06 16.34 5.5 14.33 5.08 12H7v-2H5.08c0.42-2.33 1.98-4.34 4.06-5.46L10 6v2l2 1.5L14 8V6l0.86-1.46C16.94 5.66 18.5 7.67 18.92 10H17v2h1.92c-0.42 2.33-1.98 4.34-4.06 5.46L14.86 17z" fill="currentColor"/></svg>
              <span class="scorer-name">{{ scorer.name }}</span>
              <span v-if="scorer.goals > 1" class="scorer-count">x{{ scorer.goals }}</span>
            </div>
          </div>
          <div class="stats-box" v-if="isFootball">
            <div class="stat-item" @mouseenter="showTooltip($event, $t('statistics.yellow') + ' - ' + event.home)" @mousemove="updateTooltipPos" @mouseleave="hideTooltip">
              <div class="card-min yellow"></div>
              <span class="stat-value">{{ parseInt(getStat(6, '1')) || 0 }}</span>
            </div>
            <div class="stat-item" @mouseenter="showTooltip($event, $t('statistics.red') + ' - ' + event.home)" @mousemove="updateTooltipPos" @mouseleave="hideTooltip">
              <div class="card-min red"></div>
              <span class="stat-value">{{ parseInt(getStat(7, '1')) || 0 }}</span>
            </div>
            <div class="stat-item" @mouseenter="showTooltip($event, $t('statistics.corner') + ' - ' + event.home)" @mousemove="updateTooltipPos" @mouseleave="hideTooltip">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="corner-icon"><g clip-path="url(#ch1)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H1V2.08296C3.51251 2.50448 5.49552 4.4875 5.91704 7H8V8H6H1H0V7V2V0Z" fill="currentColor"/></g><defs><clipPath id="ch1"><rect width="8" height="8" fill="white"/></clipPath></defs></svg>
              <span class="stat-value">{{ parseInt(getStat(1, '1')) || 0 }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="scoreboard-wrapper">
        <div class="live-score-display" v-if="event.livescore">
          <div class="competitor" v-if="isTennisOrTableTennis(event)"></div>
          <ScoreboardLive :sport-id="event.sportId" :livescore="event.livescore" :competitors="{home: event.home, away: event.away}" :mode="'detail'"/>
        </div>
        <div class="match-timer" v-if="!hideTimer && (event.livescore || event.status === '9')">
          <div class="">
            <span v-if="event.matchFinished" class="match-finished-badge">{{ $t('matchFinished') }}</span>
            <span v-else-if="isAboutToStart(event)" class="live-badge ping ">{{$t('periods.about_to_start')}}</span>
            <span v-else class="info-time-match ">{{ getInfoTimeMatch(event.livescore, event.sportId, event.status) }}</span>
          </div>

          <div class="">
            <Countdown :scheduled="event.scheduled" v-if="isAboutToStart(event)"/>
            <div v-else-if="event.livescore" class="match-clock" @mouseenter="showTooltip($event, $t('statistics.gametime'))" @mousemove="updateTooltipPos" @mouseleave="hideTooltip">
              {{ !hasTime(event) ? 'LIVE' : formattedMatchTime }}
            </div>
          </div>
        </div>
      </div>

      <div class="team-col away"  v-if="!isTennisOrTableTennis(event)">
        <LogoCompetitors :team-id="event.away_id" height="50px" width="50px" class="team-logo " v-if="!isTennisOrTableTennis(event)"/>
        <div class="column">
          <div class="team-name">{{ event.away }}</div>
          <div class="scorers-list" v-if="scorersByTeam.away.length > 0">
            <div class="scorer-item" v-for="scorer in scorersByTeam.away" :key="scorer.name">
              <svg class="scorer-ball" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15.93V16h2v1.93c-0.33 0.04-0.66 0.07-1 0.07s-0.67-0.03-1-0.07zm4-1.02V15l-3-2-3 2v1.91C7.06 16.34 5.5 14.33 5.08 12H7v-2H5.08c0.42-2.33 1.98-4.34 4.06-5.46L10 6v2l2 1.5L14 8V6l0.86-1.46C16.94 5.66 18.5 7.67 18.92 10H17v2h1.92c-0.42 2.33-1.98 4.34-4.06 5.46L14.86 17z" fill="currentColor"/></svg>
              <span class="scorer-name">{{ scorer.name }}</span>
              <span v-if="scorer.goals > 1" class="scorer-count">x{{ scorer.goals }}</span>
            </div>
          </div>
          <div class="stats-box" v-if="isFootball">
            <div class="stat-item" @mouseenter="showTooltip($event, $t('statistics.yellow') + ' - ' + event.away)" @mousemove="updateTooltipPos" @mouseleave="hideTooltip">
              <div class="card-min yellow"></div>
              <span class="stat-value">{{ parseInt(getStat(6, '2')) || 0 }}</span>
            </div>
            <div class="stat-item" @mouseenter="showTooltip($event, $t('statistics.red') + ' - ' + event.away)" @mousemove="updateTooltipPos" @mouseleave="hideTooltip">
              <div class="card-min red"></div>
              <span class="stat-value">{{ parseInt(getStat(7, '2')) || 0 }}</span>
            </div>
            <div class="stat-item" @mouseenter="showTooltip($event, $t('statistics.corner') + ' - ' + event.away)" @mousemove="updateTooltipPos" @mouseleave="hideTooltip">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="corner-icon"><g clip-path="url(#ch2)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H1V2.08296C3.51251 2.50448 5.49552 4.4875 5.91704 7H8V8H6H1H0V7V2V0Z" fill="currentColor"/></g><defs><clipPath id="ch2"><rect width="8" height="8" fill="white"/></clipPath></defs></svg>
              <span class="stat-value">{{ parseInt(getStat(1, '2')) || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="tooltip.visible" class="tracker-custom-tooltip" :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }">
      {{ tooltip.text }}
    </div>
  </div>
</template>

<script>
  import ScoreboardLive from "@/components/center_widgets/Live/previews/ScoreboardLive.vue";
  import LogoCompetitors from "@/components/center_widgets/LogoCompetitors.vue";
  import Countdown from "@/components/center_widgets/Live/Countdown.vue";
  import {mapGetters} from "vuex";

  export default {
    components: {LogoCompetitors, ScoreboardLive, Countdown},
    props: {
      event: Object,
      // The MatchTracker shows its own clock: no second timer next to it.
      hideTimer: { type: Boolean, default: false }
    },
    data() {
      return {
        tooltip: {
          visible: false,
          x: 0,
          y: 0,
          text: ''
        },
        timerId: null,
        livescorePollingTimer: null,
        anchorSeconds: 0,
        anchorWallMs: 0,
        tick: 0,
      }
    },
    beforeDestroy() {
      this.stopClock();
      this.stopLivescorePolling();
    },
    mounted(){
      this.setEvent(this.event)
    },
    watch:{
      'event.livescore.scoreboard': {
        handler() {
          this.setEvent(this.event);
        },
        deep: true
      },
      'event.id'(newId, oldId) {
        if (newId !== oldId) this.setEvent(this.event);
      }
    },
    methods:{
      // Tennis, table tennis and Aussie rules: the names are in the scoreboard.
      isTennisOrTableTennis(event) {
        return event && ["54094", "265917", "389537"].includes(String(event.sportId));
      },
      isAboutToStart(event) {
        return event.status === '9' || event.livescore?.scoreboard?.status === '9' ;
      },
      setEvent(newVal) {
        const ls = newVal?.Livescore || newVal?.livescore;
        if (!ls) return;
        const sb = ls.Scoreboard || ls.scoreboard;
        if (!sb) return;
        const clock = sb.Clock || sb.clock;
        const serverTime = parseInt(sb.Time || sb.time || clock?.Seconds || clock?.seconds || 0);
        if (isNaN(serverTime)) return;

        // Calcoliamo quanti secondi stiamo mostrando a video attualmente
        let currentDisplayed = 0;
        if (this.anchorWallMs !== 0) {
          const elapsedSec = Math.floor((Date.now() - this.anchorWallMs) / 1000);
          currentDisplayed = this.isCountdownSport
                  ? Math.max(0, this.anchorSeconds - elapsedSec)
                  : this.anchorSeconds + elapsedSec;
        }

        const diff = serverTime - currentDisplayed;
        let shouldSyncTime = false;

        // 1. PRIMA SINCRONIZZAZIONE
        if (this.anchorWallMs === 0) {
          shouldSyncTime = true;
        }
        // 2. SPORT CON COUNTDOWN (Basket, Hockey: il tempo SCENDE)
        else if (this.isCountdownSport) {
          if (diff < 0 || diff > 180) shouldSyncTime = true;
        }
        // 3. SPORT CLASSICI (Calcio, Tennis: il tempo SALE)
        else {
          if (diff > 0 || diff < -180) shouldSyncTime = true;
        }

        if (shouldSyncTime) {
          this.anchorSeconds = serverTime;
          this.anchorWallMs = Date.now();
        }

        // --- LOGICA DI START / STOP DEL CLOCK (FIXATA) ---

        // 🛡️ Cerchiamo lo status ovunque si trovi (se manca nella root, guardiamo nello scoreboard)
        const eventStatusStr = newVal.status || sb.Status || sb.status || '0';
        const eventStatus = parseInt(eventStatusStr);

        const clockStatus = parseInt(clock?.Status || clock?.status || 1);
        const currentPeriod = parseInt(sb.CurrentPeriod || sb.currentPeriod || 0);
        const isMatchFinished = newVal.matchFinished === true;

        // 31: Halftime | 80+: Interrupted / Break / Full time
        const isBreakPeriod = currentPeriod === 31 || currentPeriod >= 80;

        if (isMatchFinished || eventStatus === 3 || isBreakPeriod || clockStatus === 2) {
          this.stopClock();
          // Spegne anche il polling HTTP se la partita è terminata o c'è una pausa
          if (isMatchFinished || eventStatus === 3 || currentPeriod >= 100) {
            this.stopLivescorePolling();
          }
        }
        else if (eventStatus === 2 && clockStatus === 1) {
          this.startClock();               // <--- Questo fa andare avanti il timer a video (this.tick++)
          this.startLivescorePolling();    // <--- Questo riaccende le chiamate al server per il livescore
        }
      },
      startClock() {
        if (this.timerId) return;
        // Il timer fa scattare la reattività aggiornando "tick" ogni secondo
        this.timerId = setInterval(() => { this.tick++; }, 1000);
      },
      stopClock() {
        if (this.timerId) {
          clearInterval(this.timerId);
          this.timerId = null;
        }
      },
      startLivescorePolling() {
        if (this.livescorePollingTimer) return;
        this.livescorePollingTimer = setInterval(() => {
          this.$store.dispatch('detailLive/pollLivescore', {
            eventId: this.event.id,
            provider: this.event.provider || 'lsport',
          });
        }, this.liveScorePollingIntervalMs);
      },
      stopLivescorePolling() {
        if (this.livescorePollingTimer) {
          clearInterval(this.livescorePollingTimer);
          this.livescorePollingTimer = null;
        }
      },
      hasTime(event) {
        return event?.livescore?.scoreboard?.time && event.livescore.scoreboard.time !== '-1';
      },
      hasPeriod(event) {
        return event?.livescore?.scoreboard?.currentPeriod;
      },
      getInfoTimeMatch(livescore, sport, status) {
        if (status === '9') return this.$t('periods.about_to_start');
        if (!livescore || !livescore.scoreboard) return '';
        if (livescore.scoreboard.currentPeriod === '-1') return this.$t('periods.about_to_start');
        if (livescore.scoreboard.currentPeriod) {
          return this.$t('periods.' + sport + '.' + livescore.scoreboard.currentPeriod);
        }
        return '';
      },
      getMatchCurrentTime(time) {
        if (time === undefined || time === null || time === '') return '';
        const timeNum = parseInt(time, 10);
        if (isNaN(timeNum) || timeNum < 0) return '';
        var minutes = Math.floor(timeNum / 60);
        var seconds = timeNum - minutes * 60;
        return (seconds < 10) ? minutes + ':0' + seconds : minutes + ':' + seconds;
      },
      getStat(type, pos) {
        const ls = this.event && (this.event.Livescore || this.event.livescore);
        if (!ls) return 0;
        const stats = ls.Statistics || ls.statistics || [];
        const s = stats.find(stat => String(stat.Type || stat.type) == String(type));
        if (!s) return 0;
        const res = s.Results || s.results || [];
        const record = res.find(r => String(r.Position || r.position) == String(pos));
        return record ? (record.Value ?? record.value ?? 0) : 0;
      },
      showTooltip(e, text) {
        this.tooltip.text = text;
        this.tooltip.visible = true;
        this.tooltip.x = e.clientX + 15;
        this.tooltip.y = e.clientY + 15;
      },
      updateTooltipPos(e) {
        if (this.tooltip.visible) {
          this.tooltip.x = e.clientX + 15;
          this.tooltip.y = e.clientY + 15;
        }
      },
      hideTooltip() {
        this.tooltip.visible = false;
      }
    },
    computed:{
      ...mapGetters({
        'getEventsLiveDetail': 'detailLive/getEventsLiveDetail',
        'liveScorePollingIntervalMs': 'settings/getLiveScorePollingIntervalMs',
      }),
      // --- IL NUOVO OROLOGIO REATTIVO ---
      formattedMatchTime() {
        // Dichiarare this.tick qui dentro obbliga Vue a ricalcolare
        // questa stringa ogni volta che il timer scatta!
        const currentTick = this.tick;

        if (this.anchorWallMs === 0) return '00:00';

        const elapsedSec = Math.floor((Date.now() - this.anchorWallMs) / 1000);
        let totalSeconds = 0;

        if (this.isCountdownSport) {
          totalSeconds = Math.max(0, this.anchorSeconds - elapsedSec);
        } else {
          totalSeconds = this.anchorSeconds + elapsedSec;
        }

        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;

        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
      },
      // Cards and corners only make sense for football.
      isFootball() {
        return String(this.event?.sportId || '') === '6046';
      },
      isCountdownSport() {
        const sId = parseInt(this.event?.sportId || 0);
        const basketIds = [48242, 1149105, 1149097];
        const hockeyIds = [35232, 530129, 46957];
        return [...basketIds, ...hockeyIds].includes(sId);
      },
      ls() {
        return this.event && (this.event.Livescore || this.event.livescore) ? (this.event.Livescore || this.event.livescore) : null;
      },
      hasCards() {
        const stats = this.ls?.Statistics || this.ls?.statistics;
        return stats?.some(s => parseInt(s.Type || s.type) === 6 || parseInt(s.Type || s.type) === 7);
      },
      scorersByTeam() {
        const event = this.event
        if (!event || !Array.isArray(event.playerStatistics)) return { home: [], away: [] }
        const homeId = String(event.home_id || '')
        const awayId = String(event.away_id || '')
        const home = []
        const away = []
        event.playerStatistics.forEach(player => {
          const goalStat = (player.statistics || []).find(stat => stat.id === '1030')
          if (!goalStat) return
          const goals = parseInt(goalStat.value)
          if (!goals) return
          const info = { name: player.playerName, goals }
          if (String(player.teamId) === homeId) home.push(info)
          else if (String(player.teamId) === awayId) away.push(info)
        })
        return { home, away }
      },
    }
  }
</script>

<style scoped>
  /* ── Match Hero container ───────────────────────────────────────────── */
  .match-hero-live { background-size: cover; background-position: center; position: relative; padding: 4px; border-radius: 4px; }
  .hero-content { display: flex; justify-content: space-between; align-items: center; position: relative; z-index: 2; }
  .hero-content.tennis { justify-content: center; }

  /* ── Competitors ────────────────────────────────────────────────────── */
  .team-col { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; min-width: 0; gap: 10px; }
  .team-col .column { display: flex; flex-direction: column; align-items: center; max-width: 80%; }
  .team-logo { width: 60px; height: 60px; object-fit: contain; }
  .team-name { font-weight: 700; font-size: var(--font-size-6xl); color: var(--text-platform); line-height: 1.2; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

  /* ── Scorers list ────────────────────────────────────────────────────── */
  .scorers-list { display: flex; flex-direction: column; align-items: center; gap: 2px; margin-top: 4px; width: 100%; }
  .scorer-item { display: flex; align-items: center; gap: 4px; font-size: var(--font-size-md); color: var(--text-platform); line-height: 1.3; }
  .scorer-ball { width: 10px; height: 10px; flex-shrink: 0; fill: currentColor; color: var(--text-op-50-platform, #aaa); }
  .scorer-name { font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 90px; }
  .scorer-count { color: var(--color-primary, #a37e2c); font-weight: 700; flex-shrink: 0; font-size: var(--font-size-xs); }
  .own-goal-tag { color: var(--danger, #ef4444); font-size: var(--font-size-xs); font-weight: 400; }

  /* ── Stats box ───────────────────────────────────────────────────────── */
  .stats-box { display: flex; gap: 8px; margin-top: 6px; align-items: center; }
  .stat-item { display: flex; align-items: center; gap: 3px; cursor: default; }
  .stat-value { font-size: var(--font-size-xl); font-weight: 700; color: var(--text-platform); line-height: 1; }
  .card-min { width: 7px; height: 10px; border-radius: 1px; flex-shrink: 0; }
  .yellow { background: var(--warning, #fbbf24); }
  .red { background: var(--danger, #ef4444); }
  .corner-icon { color: var(--text-op-50-platform, #aaa); flex-shrink: 0; }

  /* ── Scoreboard center ──────────────────────────────────────────────── */
  .scoreboard-wrapper { flex: 0 0 140px; display: flex; flex-direction: column; align-items: center; justify-content: center; }
  .match-timer { font-size: var(--font-size-md); color: var(--color-accent); font-weight: 700; margin-top: 5px;  padding: 4px 10px; border-radius: 4px; display: flex; align-items: center; gap: 6px; }
  .match-timer .info-time-match { color: var(--color-accent); font-weight: bolder; }
  .match-timer .time-match { font-weight: lighter; }
  .live-time { font-size: var(--font-size-10xl); font-weight: 700; color: #fff;  }
  .live-date { font-size: var(--font-size-xl); color: #ccc; text-transform: uppercase; margin-top: 2px; }
  .live-score-display { font-size: var(--font-size-16xl); font-weight: 900; color: var(--text-platform);   display: flex; align-items: center;justify-content: center }
  .match-period { font-size: var(--font-size-2xl); color: var(--text-op-50-platform); text-transform: uppercase; margin-top: 6px; font-weight: 500; }

  /* ── Tooltip ────────────────────────────────────────────────────────── */
  .tracker-custom-tooltip {
    position: fixed; background: var(--bg-card); color: #fff;
    padding: 8px 14px; border-radius: 8px; font-size: var(--font-size-2xl); font-weight: 900;
    z-index: 999999; pointer-events: none; box-shadow: 0 4px 15px rgba(0,0,0,0.8);white-space: nowrap; transform: translate(0, 0)
  }

  /* ── Responsive ─────────────────────────────────────────────────────── */
  @media (max-width: 600px) {
    .team-name { font-size: var(--font-size-3xl); }
    .scoreboard-wrapper { flex: 0 0 110px; }
    .live-score-display { font-size: var(--font-size-11xl); }
    .match-timer{

    }
    .live-badge{
      padding: 4px 7px!important;
    }
    .team-logo { width: 46px!important; height: 46px!important; }

  }

</style>